export const AUTHENTICATE_USER = 'AUTHENTICATE_USER';
export const READ_USER_PROFILE = 'READ_USER_PROFILE';
export const LOG_IN = 'LOG_IN';
export const LOG_OUT = 'LOG_OUT';
export const LOAD_ASSIGNED_LICENSES = 'LOAD_ASSIGNED_LICENSES';
